"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBar = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const InputBase_1 = __importDefault(require("@material-ui/core/InputBase"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const styles_1 = require("@material-ui/styles");
const utils_1 = require("../lib/utils");
const button_1 = __importDefault(require("./button"));
const icon_1 = __importDefault(require("./icon"));
const tooltip_1 = __importDefault(require("./tooltip"));
const theme_1 = __importDefault(require("../styles/theme"));
const typography_1 = require("../styles/typography");
const useStyles = makeStyles_1.default({
    upliftSearchInput: {
        backgroundColor: theme_1.default.colors.white,
        borderRadius: '0.37rem',
        width: '100%',
        '&.Mui-focused': {
            outline: theme_1.default.outline,
        },
    },
});
const StyledIcon = styled_components_1.default(icon_1.default) `
  align-self: center;
  margin: 0 ${(props) => props.theme.spacing.xs};
`;
const StyledSearchText = styled_components_1.default.p `
  ${typography_1.defaultText}
  font-family: ${(props) => props.theme.font.family.sans};
`;
const StyledSearch = styled_components_1.default.div `
  height: 36px;
  width: 480px;
  border: 1px
    ${(props) => props.error ? props.theme.colors.error : props.theme.colors.borderDefault}
    solid;
  border-radius: 0.5rem;
  display: inline-flex;
`;
const StyledTooltip = styles_1.withStyles({
    tooltipPlacementTop: {
        margin: '15px 0',
    },
    tooltipPlacementBottom: {
        margin: '15px 0',
    },
})(tooltip_1.default);
const SearchBar = (_a) => {
    var { error = false, placeholder = 'Search', onSearch = utils_1.noop, onChange = utils_1.noop, value = '', tooltip = '', isDisabled = false } = _a, commonProps = __rest(_a, ["error", "placeholder", "onSearch", "onChange", "value", "tooltip", "isDisabled"]);
    const classes = useStyles();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("form", Object.assign({}, commonProps, { onSubmit: (event) => {
                event.preventDefault();
                onSearch(value);
            } }),
            react_1.default.createElement(StyledSearch, { "data-testid": "search-bar", error: error },
                react_1.default.createElement(StyledIcon, { name: "search", color: theme_1.default.colors.black }),
                react_1.default.createElement("div", { style: { flex: 1 } },
                    react_1.default.createElement(StyledTooltip, { text: tooltip, style: { maxWidth: '400px' } },
                        react_1.default.createElement(InputBase_1.default, { classes: { root: classes.upliftSearchInput }, "data-testid": "search-field", placeholder: placeholder, value: value, onChange: (e) => onChange(e.target.value) }))),
                react_1.default.createElement(button_1.default, { inline: true, small: true, primary: true, "data-testid": "search-button", type: "submit", disabled: isDisabled },
                    react_1.default.createElement(StyledSearchText, { "data-testid": "search-button-text" }, "Search"))))));
};
exports.SearchBar = SearchBar;
exports.default = exports.SearchBar;
